export const SHOW_ERROR = "SHOW_ERROR"
export const HIDE_ERROR = "HIDE_ERROR"

export const setShowError = (data:any) => {
    return {
        type:SHOW_ERROR,
        payload:data
    }
}

export const setHideError = (data:any) => {
    return {
        type:HIDE_ERROR,
        payload:data
    }
}